import {Widget} from "base/assets/js/widget/Widget.js";

export class JCarousel extends Widget {

	async run() {
		if( !window.jQuery ) {
			await this._import( 'jquery' );
		}
		await import( /* webpackChunkName: "jcarousel" */ 'current-desktop/assets/js/jquery.jcarousel.min.js' );
		$( this.bl() ).jcarousel( {
			scroll: 1,
			initCallback: this.initCallback,
			itemFirstInCallback: this.updateCounters,
		} );
	}

	updateCounters(carousel, button, enabled) {
		var $home = $(carousel.container[0]),
			cnt = $home.find('li').length-1,
			$prev = $home.find('.btnPrev, .jcarousel-prev-bg'),
			$next = $home.find('.btnNext, .jcarousel-next-bg');

		if (carousel.first == 1) {
			$prev.css('visibility', 'hidden');
		} else {
			$prev.css('visibility', 'visible');
		}
		if (carousel.first == cnt) {
			$next.css('visibility', 'hidden');
		} else {
			$next.css('visibility', 'visible');
		}
		$home.find('.itemInfo').html(carousel.first+' / '+cnt);
	}

	initCallback( carousel ) {
		var $home = $(carousel.container[0]),
			cnt = $home.find('li').length;

		$home.find('.btnPrev, .jcarousel-prev-bg').bind('click', function() {
			carousel.prev();
		});
		$home.find('.btnNext, .jcarousel-next-bg').bind('click', function() {
			if (carousel.first < (cnt-1)) {
				carousel.next();
			}
		});
	}
}